import React from 'react';
import Chart from 'react-apexcharts';

class SiteListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openReports: false,
    };

    this.state.chartDefaults = {
      options: {
        chart: {
          toolbar: {
            show: true
          }
        },
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 225,
            hollow: {
              margin: 0,
              size: '70%',
              background: '#fff',
              position: 'front',
              dropShadow: {
                enabled: true,
                top: 3,
                left: 0,
                blur: 4,
                opacity: 0.24
              }
            },
            track: {
              background: '#fff',
              strokeWidth: '67%',
              margin: 0, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: -3,
                left: 0,
                blur: 4,
                opacity: 0.35
              }
            },

            dataLabels: {
              name: {
                offsetY: -10,
                show: true,
                color: '#888',
                fontSize: '17px'
              },
              value: {
                formatter: function (val) {
                  return parseInt(val);
                },
                color: '#111',
                fontSize: '16px',
                show: true,
              }
            }
          }
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: ['#ABE5A1'],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100]
          }
        },
        stroke: {
          lineCap: 'round'
        },
        labels: ['Percent'],
      },
      series: [75],
    }
  }

  median(values){
    if(values.length ===0) return 0;

    values.sort(function(a,b){
      return a-b;
    });

    var half = Math.floor(values.length / 2);

    if (values.length % 2)
      return values[half];

    return (values[half - 1] + values[half]) / 2.0;
  }

  componentDidMount = () => {
    const result = this.props.siteManifest;
    const testId = this.props.id;
    const siteId = this.props.site.id;

    if(result !== undefined) {      
      let timesortedResults = Object.keys(result).sort(function(a, b){return b - a});
      if (timesortedResults.length > 30) {
        timesortedResults = timesortedResults.slice(0,29);
      }
      const latest = timesortedResults[0];
      const urlID = Object.keys(result[latest])[0];

      if(result[latest][testId] !== undefined){
        // Calculate median score. We're going to add the metrics in each
        // dimension for a total on the test and then use that to figure out our
        // median.
        const latestTestsKeys = Object.keys(result[latest][testId])
        const testScoresTotal = latestTestsKeys.map(function(value) {
          const testRunScores = result[latest][testId][value].scores;
          let score = 0;
          for (var testType in testRunScores) {
            if (testType !== 'pwa') {

              score = score + parseFloat(testRunScores[testType]);
            }
          }
          return score.toFixed(2);
        });

        const medianScore = this.median(testScoresTotal);

        let medianScoreIndex = null;
        for (let i = testScoresTotal.length; i--;) {
          const score = testScoresTotal[i];
          if (score === medianScore) {
            medianScoreIndex = i;
          }
        }

        // Test if the median scores key is valid.
        if (!result[latest][testId].hasOwnProperty(medianScoreIndex) ||
            result[latest][testId][medianScoreIndex] === null) {
          // Log the troublesome items.
          console.log('Latest results not available:');
          console.log('siteId',siteId)
          console.log('latest',latest)
          console.log('testId', testId)
          return;
        }
        const scores = result[latest][testId][medianScoreIndex].scores;
        const scoresArray = Object.entries(scores);

        function roundScore(score) {
          const numScore = parseFloat(score);
          return Math.round(numScore * 100);
        }

        const latestCharts = scoresArray.map(function(testResult) {
          const chartValue = roundScore(testResult[1]);
          const chartLabel = testResult[0];
          const chartIndex = urlID + '_' + chartLabel;

          // Don't show progessive web app score.
          if (chartLabel === 'pwa') {
            return false;
          }

          let scoreClass = "score ";
          if (chartValue <= 49) {
            scoreClass = scoreClass + 'score-red';
          }
          else if (chartValue >= 50 && chartValue <= 89) {
            scoreClass = scoreClass + 'score-orange';
          }
          else if (chartValue >= 90) {
            scoreClass = scoreClass + 'score-green';
          }

          let scoreLabel = "";
          if (chartLabel === "performance") {
            scoreLabel = "Perf";
          }
          else if (chartLabel === "best-practices") {
            scoreLabel = "BP";
          }
          else if (chartLabel === "accessibility") {
            scoreLabel = "A11y";
          }
          else if (chartLabel === "seo") {
            scoreLabel = "SEO";
          }

          return <div key={chartIndex} className={scoreClass}>{chartValue}<div className="score-label">{scoreLabel}</div></div>
        });

        let historicalSeries = [
          {
            "name" : "Performance",
            "data" : []
          },
          {
            "name" : "Accessibility",
            "data" : []
          },
          {
            "name" : "Best Practices",
            "data" : []
          },
          {
            "name" : "SEO",
            "data" : []
          }
        ];
        let xAxis = {
          "type" : "datetime",
        };

        // Generate historical chart series data.
        let numResults = timesortedResults.length;
        while (numResults--) {
          const timestamp = parseInt(timesortedResults[numResults]);

          // Skip empty scores. This can happen is lighthouse test runs fail in circleci.
          if (result[timestamp][this.props.id] === undefined ||
            !result[timestamp][this.props.id].hasOwnProperty(medianScoreIndex) ||
            result[timestamp][this.props.id][medianScoreIndex] === null) {
            // Log the troublesome items.
            console.log('Historical data not available:');
            console.log('siteId',siteId)
            console.log('latest',latest)
            console.log('testId', testId)
            continue;
          }

          const historicalResult = result[timestamp][this.props.id][medianScoreIndex].scores;
          // Update series data.
          // Perf.
          const perf = {
            "x": timestamp,
            "y": roundScore(historicalResult.performance)
          };
          historicalSeries[0].data.push(perf);
          // Access.
          const accessibility = {
            "x": timestamp,
            "y": roundScore(historicalResult.accessibility)
          };
          historicalSeries[1].data.push(accessibility);
          // Best Practices.
          const best = {
            "x": timestamp,
            "y": roundScore(historicalResult["best-practices"])
          };
          historicalSeries[2].data.push(best);
          // Seo.
          const seo = {
            "x": timestamp,
            "y": roundScore(historicalResult.seo)
          };
          historicalSeries[3].data.push(seo);
        }

        function generateHistoricalChart () {
          const lineChartConfig = {
            series: historicalSeries,
            options: {
              chart: {
                height: 150,
                width: "100%",
                type: 'line',
                toolbar: {
                  show: false,
                },
                zoom: {
                  enabled: false,
                }
              },
              stroke: {
                width: 7,
                curve: 'smooth'
              },
              xaxis: xAxis,
              markers: {
                size: 3,
                colors: ["#000"],
                strokeColors: "#fff",
                strokeWidth: 1,
                hover: {
                  size: 5,
                }
              }
            },


          };
          return <div className="chart-line"><Chart options={lineChartConfig.options} series={lineChartConfig.series} type="line" height={150} width={400} /></div>
        };

        const reportList = timesortedResults.map(function(timestamp){
          if(result[timestamp][testId]===undefined) return false;
          const testDate = new Date(parseInt(timestamp));
          const testDateStr = testDate.toDateString();
          const testRunsKeys = Object.keys(result[timestamp][testId]);
          const testRuns = testRunsKeys.map(function(index) {
            const testUrl = result[timestamp][testId][index].html
            const reportNum = parseInt(index) + 1;
            const message = "Run: " + reportNum;
            return <li key={index}><a href={testUrl} target="_blank" rel="noopener noreferrer">{message}</a></li>;
          });
          return <li key={parseInt(timestamp)} className="reports-date"><small><b>{testDateStr}</b></small><ul>{testRuns}</ul></li>;
        });

        this.setState({
          latestCharts: latestCharts,
          historicalChart: generateHistoricalChart(),
          reportList: reportList,
        });
      }
    }
  };

  render() {
    return (
        <div className="site-list-item">
          <h3 className="item-name"><a href={this.props.url} target="_blank" rel="noopener noreferrer">{this.props.title}</a></h3>
          <div className="charts">
            <div className="latest">
              <h4 className="latest-title">Lighthouse Scores</h4>
              <div className="score-cards">
                {this.state.latestScores}
                {this.state.latestCharts}
              </div>
            </div>
            <div className="historical">
              {this.state.historicalChart}
            </div>
          </div>
          <p className="reports-title"><button onClick={ () => this.setState({openReports: !this.state.openReports}) }>View Historical Reports</button></p>
          <ul className={this.state.openReports ? 'reports-list open': 'reports-list'}>
            {this.state.reportList}
          </ul>
        </div>
    );
  }
}

export default SiteListItem;